import {
  LIST_VEHICLES_FOR_BIDS,
  CHANGE_BID_STATUS,
  REGISTER_BID,
  CHANGE_MULTIPLE_BID_STATUS,
} from './config';

export async function getVehiclesForBids(competitionId) {
  const url = LIST_VEHICLES_FOR_BIDS.replace('{competitionId}', competitionId);
  const token = localStorage.getItem('token');

  const racingNumbers = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte hämta fordon');
      }
    })
    .then((data) => {
      return data?.vehicles;
    })
    .catch((err) => {
      //console.error(err);
    });

  return racingNumbers;
}

export async function changeBidStatus(competitionId, vehicleId, status) {
  const url = CHANGE_BID_STATUS;
  const token = localStorage.getItem('token');

  const body = {
    competitionId: competitionId,
    vehicleId: vehicleId,
    bidStatus: status,
  };

  const result = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err)
    });

  return result;
}

export async function registerBid(bid) {
  const url = REGISTER_BID;
  const token = localStorage.getItem('token');

  let body = {
    ...bid,
    totalBids: Number.parseInt(bid.totalBids),
    birthDate: {
      day: bid.birthDateDay,
      month: bid.birthDateMonth,
      year: bid.birthDateYear,
    },
  };

  delete body.birthDateYear;
  delete body.birthDateMonth;
  delete body.birthDateDay;

  const result = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else if (res.status === 400 || res.status === 409) {
        return res.json();
      } else {
        throw new Error('Could not register bid');
      }
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err)
    });

  return result;
}

export async function changeMultipleBidStatus(competitionId, status) {
  const url = CHANGE_MULTIPLE_BID_STATUS;
  const token = localStorage.getItem('token');

  const body = {
    competitionId: competitionId,
    bidStatus: status,
  };

  const result = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err)
    });

  return result;
}
